// src/data/exercises/L2_04.js

const accountOptions = [
  '売上原価', '売掛金', '売上', '仕入', '商品'];

export const L2_04 = {
  title: '簿記　3級（第218-4回）',
  questions: [
    {
      id: 'q1',
      type: 'JOURNAL_ENTRY',
        content: {

       parts: [
        { type: 'ruby', text: '静岡商事', ruby: 'しずおかしょうじ' },
        { type: 'ruby', text: '株式会社', ruby: 'かぶしきがいしゃ' },
        { type: 'text', value: 'から' },
        { type: 'ruby', text: '商品', ruby: 'しょうひん' },
        { type: 'text', value: '（' },
        { type: 'ruby', text: '売価', ruby: 'ばいか' },
        { type: 'text', value: '￥2,100 ' },
        { type: 'ruby', text: '原価', ruby: 'げんか' },
        { type: 'text', value: '￥1,500）が' },
        { type: 'ruby', text: '返品', ruby: 'へんぴん' },
        { type: 'text', value: 'され、' },
        { type: 'ruby', text: '代金', ruby: 'だいきん' },
        { type: 'text', value: 'は' },
        { type: 'ruby', text: '売掛金', ruby: 'うりかけきん' },
        { type: 'text', value: 'と' },
        { type: 'ruby', text: '相殺', ruby: 'そうさい' },
        { type: 'text', value: 'した。ただし、' },
        { type: 'ruby', text: '当社', ruby: 'とうしゃ' },
        { type: 'text', value: 'は、' },
        { type: 'ruby', text: '商品販売取引', ruby: 'しょうひんはんばいとりひき' },
        { type: 'text', value: 'に' },
        { type: 'ruby', text: '関', ruby: 'かん' },
        { type: 'text', value: 'して、' },
        { type: 'ruby', text: '販売', ruby: 'はんばい' },
        { type: 'text', value: 'のつど、' },
        { type: 'ruby', text: '売上原価', ruby: 'うりあげげんか' },
        { type: 'text', value: 'に' },
        { type: 'ruby', text: '振', ruby: 'ふ' },
        { type: 'text', value: 'り' },
        { type: 'ruby', text: '替', ruby: 'か' },
        { type: 'text', value: 'える' },
        { type: 'ruby', text: '方法', ruby: 'ほうほう' },
        { type: 'text', value: '（' },
        { type: 'ruby', text: '売上原価対立法', ruby: 'うりあげげんかたいりつほう' },
        { type: 'text', value: '）で' },
        { type: 'ruby', text: '記帳', ruby: 'きちょう' },
        { type: 'text', value: 'している。' }
    ]

      },
      table: {
        options: accountOptions,
      },
      // Đáp án có 1 dòng Nợ và 2 dòng Có
      answer: [
        { debitAccount: '売上', debitAmount: 2100, creditAccount: '売掛金', creditAmount: 2100 },
        { debitAccount: '商品', debitAmount: 1500, creditAccount: '売上原価', creditAmount: 1500 },
              ],
       // Giải thích chi tiết khi trả lời ĐÚNG (có định dạng)
      explanation_correct: {
        parts: [
          { type: 'text', value: '商品（売価￥2,100　原価￥1,500）が返品され \n' },
          { type: 'text', value: '①商品の返品なので、売上が消滅（マイナス）します。\n' },
          { type: 'styled', value: '売上の消滅（マイナス）は借方（左・Ｄｒ）に記入します。\n\n', color: 'red', bold: true },
          { type: 'text', value: '売掛金と相殺した\n' },
          { type: 'text', value: '②売上と相殺するので、売掛金が減少（マイナス）します。\n' },
          { type: 'styled', value: '売掛金の減少（マイナス）は貸方（右・Ｃｒ）に記入します。\n\n', color: 'red', bold: true },
          { type: 'text', value: '商品（売価￥2,100　原価￥1,500）が返品され・売上原価に振り替える方法（売上原価対立法）で記帳している\n' },
          { type: 'text', value: '③商品が減少（マイナス）します。\n' },
          { type: 'styled', value: '商品の減少（マイナス）は借方（左・Ｄｒ）に記入します。\n\n', color: 'red', bold: true },
          { type: 'text', value: '売上原価に振り替える方法（売上原価対立法）記帳している \n' },
          { type: 'text', value: '④売上原価が消滅（マイナス）します\n' },
          { type: 'styled', value: '売上原価の消滅（マイナス）は貸方（右・Ｃｒ）に記入します。\n\n', color: 'red', bold: true },
        
        ]
      },

      // Gợi ý 2 cấp độ khi trả lời SAI
      hints: {
        account: [
          // Gợi ý lần 1, 2
`商品（売価￥2,100　原価￥1,500）が返品され
①商品の返品なので、売上が消滅（マイナス）します。
　　       
売掛金と相殺した
②売上と相殺するので、売掛金が減少（マイナス）します。
　
商品（売価￥2,100　原価￥1,500）が返品され・売上原価に振り替える方法（売上原価対立法）で記帳している
③商品が減少（マイナス）します。
　　
売上原価に振り替える方法（売上原価対立法）記帳している
④売上原価が消滅（マイナス）します
　　  `,
          // Gợi ý lần 3 (chi tiết hơn, có định dạng)
          {
            parts: [
          { type: 'text', value: '商品（売価￥2,100　原価￥1,500）が返品され \n' },
          { type: 'text', value: '①商品の返品なので、売上が消滅（マイナス）します。\n' },
          { type: 'styled', value: '売上の消滅（マイナス）は借方（左・Ｄｒ）に記入します。\n\n', color: 'red', bold: true },
          { type: 'text', value: '売掛金と相殺した\n' },
          { type: 'text', value: '②売上と相殺するので、売掛金が減少（マイナス）します。\n' },
          { type: 'styled', value: '売掛金の減少（マイナス）は貸方（右・Ｃｒ）に記入します。\n\n', color: 'red', bold: true },
          { type: 'text', value: '商品（売価￥2,100　原価￥1,500）が返品され・売上原価に振り替える方法（売上原価対立法）で記帳している\n' },
          { type: 'text', value: '③商品が減少（マイナス）します。\n' },
          { type: 'styled', value: '商品の減少（マイナス）は借方（左・Ｄｒ）に記入します。\n\n', color: 'red', bold: true },
          { type: 'text', value: '売上原価に振り替える方法（売上原価対立法）記帳している \n' },
          { type: 'text', value: '④売上原価が消滅（マイナス）します\n' },
          { type: 'styled', value: '売上原価の消滅（マイナス）は貸方（右・Ｃｒ）に記入します。\n\n', color: 'red', bold: true },
        
        ]
          }
        ],
       
      },
    },
  ],
};